import script from "./common-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./common-dialog.vue?vue&type=script&setup=true&lang=js"

import "./common-dialog.vue?vue&type=style&index=0&id=1037eeb0&lang=scss&scoped=true"
import "./common-dialog.vue?vue&type=style&index=1&id=1037eeb0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1037eeb0"]])

export default __exports__